"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
require("./styles/Image.scss");
var Image = /** @class */ (function (_super) {
    __extends(Image, _super);
    function Image(props) {
        var _this = _super.call(this, props) || this;
        _this.state = { content: '' };
        return _this;
    }
    Image.prototype.shouldComponentUpdate = function (nextState) {
        return this.state.content !== nextState.content;
    };
    Image.prototype.componentDidUpdate = function (prevProps) {
        if (this.props.src !== prevProps.src) {
            this.setState({ content: '' });
        }
    };
    Image.prototype.componentDidMount = function () {
        this._isMounted = true;
    };
    Image.prototype.componentWillUnmount = function () {
        this._isMounted = false;
    };
    Image.prototype.render = function () {
        if (!this.isSvg() && !this.isRawSvg()) {
            var resize = function (e) {
                if (e.target.getAttribute('width') === null) {
                    e.target.width = e.target.width / 2;
                }
            };
            var className = ['img', this.props.className];
            return (React.createElement("img", { onLoad: resize, src: this.props.src, className: className.join(' '), width: this.props.width, alt: this.props.altText }));
        }
        else {
            if (this.isSvg() && !this.state.content) {
                this.fetchSvg();
                return null;
            }
            var className = ['img', 'svg', this.props.className];
            var content = this.state.content;
            var src = this.props.src;
            if (this.isRawSvg()) {
                content = this.props.src;
                src = undefined;
            }
            return (React.createElement("span", { className: className.join(' '), "data-src": src, dangerouslySetInnerHTML: { __html: content } }));
        }
    };
    Image.prototype.isSvg = function () {
        return String(this.props.src).match(/.svg$/);
    };
    Image.prototype.isRawSvg = function () {
        return String(this.props.src).indexOf('<svg') === 0;
    };
    Image.prototype.fetchSvg = function () {
        var _this = this;
        var headers = {
            'Content-Type': 'image/svg+xml'
        };
        fetch(this.props.src, { headers: headers }).then(function (response) {
            response.text().then(function (content) {
                if (!_this._isMounted) {
                    return;
                }
                _this.setState({
                    content: content
                });
            });
        });
    };
    return Image;
}(React.Component));
exports.default = Image;
